import React from 'react';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <section id={id} className={`py-24 md:py-32 w-full ${className}`} data-id="element-219">
      <div className="max-w-5xl mx-auto px-6" data-id="element-220">{children}</div>
    </section>;
}